<template>
  <PlatformLayout title="Избранное" :show-guest-banner="false">
    <div class="fav-page">
      <section class="fav-page__expert-banner" aria-label="Согласование с экспертом">
        <div class="fav-page__expert-banner-text">
          <p class="fav-page__expert-banner-title">Список ВУЗов готов?</p>
          <p class="fav-page__expert-banner-sub">
            Отправьте избранные программы эксперту Mentor Me для согласования
          </p>
        </div>
        <button type="button" class="fav-page__expert-btn" @click="sendToTelegram">
          <img src="@/assets/icons/talk.svg" alt="" class="fav-page__expert-btn-icon" />
          Утверждение с экспертом
        </button>
      </section>

      <div class="fav-page__toolbar">
        <div class="fav-page__search">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
            <circle cx="11" cy="11" r="8" />
            <path d="M21 21l-4.35-4.35" />
          </svg>
          <input
            v-model="searchModel"
            type="search"
            placeholder="Поиск по программе или университету…"
            @input="scheduleSearch"
            @keyup.enter="updateFilters"
          />
        </div>

        <div class="fav-page__sort fav-page__sort--desktop">
          <label class="fav-page__sort-label" for="fav-sort">Сортировка</label>
          <select id="fav-sort" v-model="sortBy" class="fav-page__sort-select" @change="updateFilters">
            <option v-for="opt in sort" :key="opt.id" :value="opt.id">{{ opt.title }}</option>
          </select>
        </div>

        <button type="button" class="fav-page__sort-mob" @click="isSelect = true">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M3 6h18M7 12h10M11 18h6" />
          </svg>
          Сортировка
        </button>
      </div>

      <section class="fav-page__results" aria-label="Избранные программы">
        <p v-if="!loading" class="fav-page__count">
          <template v-if="favs.length">
            <strong>{{ favs.length }}</strong> {{ programsCountLabel }}
          </template>
          <template v-else>Нет программ в избранном</template>
        </p>
        <p v-else class="fav-page__count fav-page__count--skeleton" aria-hidden="true">
          <span class="sk sk--text" style="display: inline-block; width: 160px; height: 16px;" />
        </p>

        <div v-if="loading" class="fav-page__block">
          <div v-for="n in 4" :key="n" class="fav-page__block__in">
            <div class="fav-page__skeleton" />
          </div>
        </div>

        <div v-else-if="favs.length" class="fav-page__block">
          <div v-for="item in favs" :key="item.id" class="fav-page__block__in">
            <newCardComponent :item="normalizeProgram(item)" @newFav="onFavChanged" />
          </div>
        </div>

        <div v-else class="fav-page__empty">
          <div class="fav-page__empty-icon" aria-hidden="true">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
          </div>
          <h2 class="fav-page__empty-title">Избранное пусто</h2>
          <p class="fav-page__empty-text">
            Добавляйте программы в избранное при поиске — они появятся здесь.
          </p>
          <router-link to="/programs" class="fav-page__empty-link">Поиск программ</router-link>
        </div>
      </section>
    </div>

    <teleport to="body">
      <div v-if="isSelect" class="fav-sheet-backdrop" @click="isSelect = false">
        <div class="fav-sheet" @click.stop>
          <div class="fav-sheet__handle" />
          <h2 class="fav-sheet__title">Сортировка</h2>
          <ul class="fav-sheet__list">
            <li v-for="opt in sort" :key="opt.id">
              <button
                type="button"
                class="fav-sheet__option"
                :class="{ 'fav-sheet__option--active': sortBy === opt.id }"
                @click="applySort(opt.id)"
              >
                {{ opt.title }}
                <svg v-if="sortBy === opt.id" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.6907 16.8533L18.3573 8.85333L16.3093 7.14667L10.576 14.0253L7.60933 11.0573L5.724 12.9427L9.724 16.9427L10.756 17.9747L11.6907 16.8533Z" fill="#e8192c" />
                </svg>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </teleport>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from '@/components/platform/PlatformLayout.vue';
import newCardComponent from '@/components/newCardComponent.vue';
import axios from 'axios';

export default {
  name: 'FavouritePrograms',
  components: { PlatformLayout, newCardComponent },
  data() {
    return {
      favs: [],
      searchModel: '',
      sortBy: 0,
      loading: false,
      isSelect: false,
      searchTimer: null,
      sort: [
        { title: 'Выбор', id: 0, type1: '', order_by: 'asc' },
        { title: 'TOП-50', id: 1, type1: 'top', order_by: 'asc' },
        { title: 'TOП-150', id: 2, type1: 'top', order_by: 'desc' },
        { title: 'ВНЕ TOП-150', id: 3, type1: 'top', order_by: 'desc' },
        { title: 'Выбор наших менти', id: 5, type1: 'is_student_choose', order_by: 'asc' },
      ],
    };
  },
  computed: {
    programsCountLabel() {
      const n = this.favs.length;
      const m10 = n % 10;
      const m100 = n % 100;
      if (m10 === 1 && m100 !== 11) return 'программа';
      if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return 'программы';
      return 'программ';
    },
  },
  created() {
    this.getPage();
  },
  beforeUnmount() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },
  methods: {
    authHeaders() {
      return { Authorization: `Bearer ${localStorage.getItem('access_token')}` };
    },
    sendToTelegram() {
      const message = 'Добрый день. Предварительный список ВУЗов выбран. Готов обсудить с экспертом';
      window.open(`https://t.me/mentor_me_kz?text=${encodeURIComponent(message)}`, '_blank');
    },
    normalizeProgram(item) {
      if (!item) return item;
      const images = item.images?.length
        ? item.images
        : item.image
          ? [{ image: item.image }]
          : [];
      return {
        ...item,
        is_favourite: 1,
        images,
        programName: item.programName || item.name,
        university: typeof item.university === 'string' ? item.university : item.university?.title,
        subcategory: item.subcategory || (item.category
          ? { category: { title: item.category } }
          : undefined),
      };
    },
    buildParams() {
      const selected = this.sort.find((item) => item.id == this.sortBy) || this.sort[0];
      return {
        search: this.searchModel,
        id: selected.id,
        sort: selected.type1,
        order_by: selected.order_by,
      };
    },
    scheduleSearch() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.updateFilters(), 350);
    },
    async getPage() {
      this.loading = true;
      try {
        const res = await axios.get('/platform/client/users/favourites', {
          headers: this.authHeaders(),
          params: this.buildParams(),
        });
        this.favs = res.data.universityPrograms || [];
      } catch (e) {
        console.error(e);
        this.favs = [];
      } finally {
        this.loading = false;
      }
    },
    async updateFilters() {
      this.loading = true;
      try {
        const res = await axios.get('/platform/client/users/favourites', {
          headers: this.authHeaders(),
          params: this.buildParams(),
        });
        this.favs = res.data.universityPrograms || [];
      } catch (e) {
        console.error('Error updating favourites:', e);
      } finally {
        this.loading = false;
      }
    },
    onFavChanged() {
      this.updateFilters();
    },
    applySort(id) {
      this.sortBy = id;
      this.isSelect = false;
      this.updateFilters();
    },
  },
};
</script>

<style lang="scss" scoped>
.fav-page {
  font-family: 'Manrope', sans-serif;
  -webkit-font-smoothing: antialiased;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.fav-page__expert-banner {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 14px;
  background: linear-gradient(135deg, #11415d 0%, #1a6a94 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 20px rgba(17, 65, 93, 0.22);

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 18px 22px;
  }
}

.fav-page__expert-banner-text {
  flex: 1;
  min-width: 0;
}

.fav-page__expert-banner-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 800;
  color: #fff;
  line-height: 1.3;

  @media (min-width: 768px) {
    font-size: 17px;
  }
}

.fav-page__expert-banner-sub {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.45;
}

.fav-page__expert-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 12px 20px;
  border: 1.5px solid #e8192c;
  border-radius: 12px;
  background: transparent;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: #ff4d5e;
  }

  @media (min-width: 768px) {
    width: auto;
    min-width: 280px;
  }
}

.fav-page__expert-btn-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
}

.fav-page__toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: stretch;
}

.fav-page__search {
  flex: 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #e8eaed;
  border-radius: 12px;
  padding: 0 16px;
  min-height: 48px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  color: #9ca3af;

  input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 14px;
    font-family: inherit;
    color: #111827;
    background: transparent;

    &::placeholder { color: #9ca3af; }
  }
}

.fav-page__sort--desktop {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding: 8px 14px;
  background: #fff;
  border: 1px solid #e8eaed;
  border-radius: 12px;
  min-width: 180px;

  @media (min-width: 768px) {
    display: flex;
  }
}

.fav-page__sort-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #9ca3af;
}

.fav-page__sort-select {
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  color: #111827;
  cursor: pointer;
  outline: none;
}

.fav-page__sort-mob {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  border-radius: 12px;
  border: 1px solid #e8eaed;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  font-family: inherit;

  @media (min-width: 768px) {
    display: none;
  }
}

.fav-page__count {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;

  strong { color: #111827; }
  &--muted { color: #9ca3af; }
}

.fav-page__block {
  display: flex;
  flex-wrap: wrap;
  gap: 2%;
  row-gap: 20px;
}

.fav-page__block__in {
  width: 49%;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
  }
}

.fav-page__skeleton {
  height: 280px;
  border-radius: 10px;
  background: linear-gradient(90deg, #f0f1f3 25%, #e8eaed 50%, #f0f1f3 75%);
  background-size: 200% 100%;
  animation: fav-shimmer 1.2s ease-in-out infinite;
}

@keyframes fav-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.fav-page__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  border-radius: 16px;
  border: 1px dashed #d1d5db;
  background: #fff;
}

.fav-page__empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin-bottom: 16px;
  border-radius: 50%;
  background: #f3f5f7;
  color: #9ca3af;
}

.fav-page__empty-title {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.fav-page__empty-text {
  margin: 0 0 20px;
  max-width: 420px;
  font-size: 14px;
  line-height: 1.6;
  color: #6b7280;
}

.fav-page__empty-link {
  display: inline-flex;
  padding: 10px 20px;
  border-radius: 10px;
  background: #11415d;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;

  &:hover { background: #1a5a7a; }
}

.fav-sheet-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 200;
  display: flex;
  align-items: flex-end;
}

.fav-sheet {
  width: 100%;
  max-height: 70vh;
  background: #fff;
  border-radius: 20px 20px 0 0;
  padding: 12px 16px 28px;
}

.fav-sheet__handle {
  width: 46px;
  height: 8px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 0 auto 12px;
}

.fav-sheet__title {
  margin: 0 0 16px;
  text-align: center;
  font-size: 18px;
  font-weight: 800;
  color: #111827;
}

.fav-sheet__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.fav-sheet__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px 4px;
  border: none;
  border-bottom: 1px solid #f0f1f3;
  background: none;
  font-size: 16px;
  font-family: inherit;
  color: #111827;
  cursor: pointer;
  text-align: left;

  &--active {
    font-weight: 700;
    color: #e8192c;
  }
}
</style>
